export default [
    {
        //---------------------------------------- TEXTURES
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path: [
            'textures/environmentMap/px.jpg',
            'textures/environmentMap/nx.jpg',
            'textures/environmentMap/py.jpg',
            'textures/environmentMap/ny.jpg',
            'textures/environmentMap/pz.jpg',
            'textures/environmentMap/nz.jpg'
        ]
    },
    {
        name: 'grassColorTexture',
        type: 'texture',
        path: 'textures/dirt/color.jpg'
    },
    {
        name: 'grassNormalTexture',
        type: 'texture',
        path: 'textures/dirt/normal.jpg'
    },
    {
        name: 'brainModel',
        type: 'objModel',
        path: 'models/Brain/bigbrain_small.obj'
        //path: 'models/Brain/lp_brain.obj'
    },
    {
        name: 'logoStar3',
        type: 'objModel',
        path: 'models/Logo/star_3_cut2.obj'
    },
    {
        name: 'centerTri',
        type: 'objModel',
        path: 'models/Logo/center_tri.obj'
    },
    {
        //---------------------------------------- FONTS
        name: 'daysOne3DFont',
        type: 'font',
        path: 'fonts/Days_One/Days_One_Regular.json'
    }
    
]